<ui-section [title]="'TAILORED_WIDGET.TEMPLATE.CARD_TITLE.CUSTOMIZATION' | translate">
    <ui-section-content class="medium-margin-bottom">
        <ng-container #editorHost />
    </ui-section-content>
</ui-section>
